import React from "react";
import { ArrowLeft, X } from "lucide-react";
import { Sheet, SheetClose } from "@/components/ui/sheet";
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  onBack?: () => void;
  showBackButton?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onBack, showBackButton = false }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gradient-to-r from-gebeya-pink to-gebeya-orange p-3 text-white flex justify-between items-center">
      <div className="flex items-center space-x-2">
        {showBackButton && (
          <button 
            onClick={onBack} 
            className="mr-2 p-1 hover:bg-white/10 rounded-full transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="h-5 w-5 text-white" />
          </button>
        )}
        <div className="font-medium text-lg">{t('support.jitumeSupport')}</div>
      </div>
      
      <SheetClose className="p-1 hover:bg-white/10 rounded-full transition-colors" aria-label="Close chat">
        <X className="h-5 w-5 text-white" strokeWidth={2.5} />
      </SheetClose>
    </div>
  );
};

export default Header; 